import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M11 4h6l3 7H8l3-7Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 11v5a2 2 0 0 1-2 2H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "LampWallUp";
const LampWallUp = memo(themed(Icon));
export {
  LampWallUp
};
//# sourceMappingURL=lamp-wall-up.js.map
